import { Button, Row, Select, Col, Spin } from "antd";
import React, { Component } from "react";
import ReactHtmlTableToExcel from "react-html-table-to-excel";
import Card from "../../../components/Card";
import MainLayout from "../../../components/Layout/MainLayout";
import { AxiosGetSecretApi } from "../../../utils/fetchApi";
import StaticClass from "../../../utils/staticClass";
import ChartPrint from "../../Statistic/TablePrint";
import "../thong-ke.scss";

export default class ThongKe5000 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedKhu: undefined,
      dataTable: [],
      dataAndtTable: null,
      listPhanKhu: [],
      isLoading: false,
      tableDropdown: true
    };

    this.length = 0
  }
  async componentDidMount() {
    this.getDataTable();
    this.getDataPhanKhu();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.isUpdate !== prevState.isUpdate) {
      this.setDataTable(this.dataTable);
    }
  }

  onResetButton = () => {
    this.getDataTable("TimMoi");

    // this.setState({
    //   selectedKhu: undefined,
    //   dataTable: null
    // });
  };

  async getDataPhanKhu() {
    let res = await AxiosGetSecretApi("/api/qh-phan-khu/cbTenDuAn");
    if (res && Array.isArray(res)) {
      this.setState({
        listPhanKhu: res,
      });
      this.listPhanKhu = res;
    }
  }

  async getDataTable(e) {
    for(let i = 0; i< this.length; i++){
      this.setState({
        [`${i}_pk`]: false
      })
    }
    this.setState({
      isLoading: true,
    });
    let url = "/api/thongke/qh-phan-khu?";
    if (this.state.selectedKhu && e !== "TimMoi") {
      url += `MaPhanKhu=${this.state.selectedKhu}`;
    }

    let res = await AxiosGetSecretApi(url);
    if (res && Array.isArray(res)) {
      let data = res.slice();
      data.forEach((e) => {
        if (e.Children) {
          e.Children = JSON.parse(e.Children);
        }
      });
      // return

      let table = data.map((e) => (
        <>
          <tr>
            <td style={{ fontWeight: "bold" }}>{e.TenPhanKhu}</td>
            <td style={{ fontWeight: "bold" }}>Diện tích (ha)</td>
            <td>{e.TongDDD ? StaticClass.formatPrice(e.TongDDD) : "-"}</td>
            <td>{e.DCC ? StaticClass.formatPrice(e.DCC) : "0"}</td>
            <td>{e.DCXMN ? StaticClass.formatPrice(e.DCXMN) : "0"}</td>
            <td>{e.DTHCS ? StaticClass.formatPrice(e.DTHCS) : "0"}</td>
            <td>0</td>
            <td>{e.DNNOQH ? StaticClass.formatPrice(e.DNNOQH) : "0"}</td>
            <td>{e.DCCNO ? StaticClass.formatPrice(e.DCCNO) : "0"}</td>
            <td>{e.DDNB ? StaticClass.formatPrice(e.DDNB) : "0"}</td>
            <td>{e.DBDX ? StaticClass.formatPrice(e.DBDX) : "0"}</td>
          </tr>

          {e.Children &&
            e.Children.map((o) => (
              <>
                <tr>
                  <td rowspan="2">{o.TenPhanKhu}</td>
                  <td>Diện tích (ha)</td>
                  <td>{o.DienTich[0].TongDDD ? StaticClass.formatPrice(o.DienTich[0].TongDDD) : "0"}</td>
                  <td>{o.DienTich[0].DCC ? StaticClass.formatPrice(o.DienTich[0].DCC) : "0"}</td>
                  <td>{o.DienTich[0].DCXMN ? StaticClass.formatPrice(o.DienTich[0].DCXMN) : "0"}</td>
                  <td>{o.DienTich[0].DTHCS ? StaticClass.formatPrice(o.DienTich[0].DTHCS) : "0"}</td>
                  <td>0</td>
                  <td>{o.DienTich[0].DNNOQH ? StaticClass.formatPrice(o.DienTich[0].DNNOQH) : "0"}</td>
                  <td>{o.DienTich[0].DCCNO ? StaticClass.formatPrice(o.DienTich[0].DCCNO) : "0"}</td>
                  <td>{o.DienTich[0].DDNB ? StaticClass.formatPrice(o.DienTich[0].DDNB) : "0"}</td>
                  <td>{o.DienTich[0].DBDX ? StaticClass.formatPrice(o.DienTich[0].DBDX) : "0"}</td>
                  {/* <td>{o.DienTich[0].TongDDD}</td>
                <td>{o.DienTich[0].DCC}</td>
                <td>{o.DienTich[0].DCXMN}</td>
                <td>{o.DienTich[0].DTHCS}</td>
                <td>&nbsp;</td>
                <td>{o.DienTich[0].DNNOQH}</td>
                <td>{o.DienTich[0].DCCNO}</td>
                <td>{o.DienTich[0].DDNB}</td>
                <td>{o.DienTich[0].DBDX}</td> */}
                </tr>

                <tr>
                  <td>Mật độ (%)</td>
                  <td>
                    {e.TongDDD && o.DienTich[0].TongDDD
                      ? StaticClass.formatPrice(((o.DienTich[0].TongDDD / e.TongDDD) * 100).toFixed(3))
                      : "0"}
                  </td>
                  <td>
                    {e.TongDDD && o.DienTich[0].DCC
                      ? StaticClass.formatPrice(((o.DienTich[0].DCC / e.TongDDD) * 100).toFixed(3))
                      : "0"}
                  </td>
                  <td>
                    {e.TongDDD && o.DienTich[0].DCXMN
                      ? StaticClass.formatPrice(((o.DienTich[0].DCXMN / e.TongDDD) * 100).toFixed(3))
                      : "0"}
                  </td>
                  <td>
                    {e.TongDDD && o.DienTich[0].DTHCS
                      ? StaticClass.formatPrice(((o.DienTich[0].DTHCS / e.TongDDD) * 100).toFixed(3))
                      : "0"}
                  </td>
                  <td>0</td>
                  <td>
                    {e.TongDDD && o.DienTich[0].DNNOQH
                      ? StaticClass.formatPrice(((o.DienTich[0].DNNOQH / e.TongDDD) * 100).toFixed(3))
                      : "0"}
                  </td>
                  <td>
                    {e.TongDDD && o.DienTich[0].DCCNO
                      ? StaticClass.formatPrice(((o.DienTich[0].DCCNO / e.TongDDD) * 100).toFixed(3))
                      : "0"}
                  </td>
                  <td>
                    {e.TongDDD && o.DienTich[0].DDNB
                      ? StaticClass.formatPrice(((o.DienTich[0].DDNB / e.TongDDD) * 100).toFixed(3))
                      : "0"}
                  </td>
                  <td>
                    {e.TongDDD && o.DienTich[0].DBDX
                      ? StaticClass.formatPrice(((o.DienTich[0].DBDX / e.TongDDD) * 100).toFixed(3))
                      : "0"}
                  </td>
                </tr>
              </>
            ))}
        </>
      ));

      this.setState({
        tableDropdown: this.state.selectedKhu && e !== "TimMoi" ? false: true,
        dataTable: table,
      });
      this.dataTable = data;
      this.setDataTable(data);
    } else {
      this.setState({
        tableDropdown: this.state.selectedKhu && e !== "TimMoi" ? false: true,
        dataTable: null,
        dataAndtTable: null,
      });
    }
    this.setState({
      isLoading: false,
    });
  }

  setDataTable(data) {
    let convertData = [];
    this.length = data.length
    data.forEach((e, i) => {
      let fixData = {
        ...e,
        TenPhanKhu: (
          <div style={{ display: "flex", alignItems: "center" }}>
            <div
              class={
                this.state[`${i}_pk`] ? "arrow-up-5000" : "arrow-down-5000"
              }
              onClick={() => {
                this.setState({
                  isUpdate: !this.state.isUpdate,
                  [`${i}_pk`]: !this.state[`${i}_pk`],
                });
              }}
              style={{ marginRight: "10px" }}
            ></div>
            <div>{e.TenPhanKhu}</div>
          </div>
        ),
      };

      convertData.push(fixData);
    });

    let dataTable = convertData.map((e, i) => {
      return (
        <>
          <tr key={i}>
            <td style={{ fontWeight: "bold" }}>{e.TenPhanKhu}</td>
            <td style={{ fontWeight: "bold" }}>Diện tích (ha)</td>
            <td>{e.TongDDD ? StaticClass.formatPrice(e.TongDDD) : "-"}</td>
            <td>{e.DCC ? StaticClass.formatPrice(e.DCC) : "0"}</td>
            <td>{e.DCXMN ? StaticClass.formatPrice(e.DCXMN) : "0"}</td>
            <td>{e.DTHCS ? StaticClass.formatPrice(e.DTHCS) : "0"}</td>
            <td>0</td>
            <td>{e.DNNOQH ? StaticClass.formatPrice(e.DNNOQH) : "0"}</td>
            <td>{e.DCCNO ? StaticClass.formatPrice(e.DCCNO) : "0"}</td>
            <td>{e.DDNB ? StaticClass.formatPrice(e.DDNB) : "0"}</td>
            <td>{e.DBDX ? StaticClass.formatPrice(e.DBDX) : "0"}</td>
          </tr>

          {e.Children &&
            e.Children.map((o, index) => {
              if (this.state[`${i}_pk`])
                return (
                  <>
                    <tr>
                      <td rowspan="2">{o.TenPhanKhu}</td>
                      <td>Diện tích (ha)</td>
                      <td>
                        {o.DienTich[0].TongDDD ? StaticClass.formatPrice(o.DienTich[0].TongDDD) : "0"}
                      </td>
                      <td>{o.DienTich[0].DCC ? StaticClass.formatPrice(o.DienTich[0].DCC) : "0"}</td>
                      <td>{o.DienTich[0].DCXMN ? StaticClass.formatPrice(o.DienTich[0].DCXMN) : "0"}</td>
                      <td>{o.DienTich[0].DTHCS ? StaticClass.formatPrice(o.DienTich[0].DTHCS) : "0"}</td>
                      <td>0</td>
                      <td>
                        {o.DienTich[0].DNNOQH ? StaticClass.formatPrice(o.DienTich[0].DNNOQH) : "0"}
                      </td>
                      <td>{o.DienTich[0].DCCNO ? StaticClass.formatPrice(o.DienTich[0].DCCNO) : "0"}</td>
                      <td>{o.DienTich[0].DDNB ? StaticClass.formatPrice(o.DienTich[0].DDNB) : "0"}</td>
                      <td>{o.DienTich[0].DBDX ? StaticClass.formatPrice(o.DienTich[0].DBDX) : "0"}</td>
                    </tr>

                    <tr>
                      <td>Mật độ (%)</td>
                      <td>
                        {e.TongDDD && o.DienTich[0].TongDDD
                          ? StaticClass.formatPrice(((o.DienTich[0].TongDDD / e.TongDDD) * 100).toFixed(
                              3
                            ))
                          : "0"}
                      </td>
                      <td>
                        {e.TongDDD && o.DienTich[0].DCC
                          ? StaticClass.formatPrice(((o.DienTich[0].DCC / e.TongDDD) * 100).toFixed(3))
                          : "0"}
                      </td>
                      <td>
                        {e.TongDDD && o.DienTich[0].DCXMN
                          ? StaticClass.formatPrice(((o.DienTich[0].DCXMN / e.TongDDD) * 100).toFixed(3))
                          : "0"}
                      </td>
                      <td>
                        {e.TongDDD && o.DienTich[0].DTHCS
                          ? StaticClass.formatPrice(((o.DienTich[0].DTHCS / e.TongDDD) * 100).toFixed(3))
                          : "0"}
                      </td>
                      <td>0</td>
                      <td>
                        {e.TongDDD && o.DienTich[0].DNNOQH
                          ? StaticClass.formatPrice(((o.DienTich[0].DNNOQH / e.TongDDD) * 100).toFixed(3))
                          : "0"}
                      </td>
                      <td>
                        {e.TongDDD && o.DienTich[0].DCCNO
                          ? StaticClass.formatPrice(((o.DienTich[0].DCCNO / e.TongDDD) * 100).toFixed(3))
                          : "0"}
                      </td>
                      <td>
                        {e.TongDDD && o.DienTich[0].DDNB
                          ? StaticClass.formatPrice(((o.DienTich[0].DDNB / e.TongDDD) * 100).toFixed(3))
                          : "0"}
                      </td>
                      <td>
                        {e.TongDDD && o.DienTich[0].DBDX
                          ? StaticClass.formatPrice(((o.DienTich[0].DBDX / e.TongDDD) * 100).toFixed(3))
                          : "0"}
                      </td>
                    </tr>
                  </>
                );
            })}
        </>
      );
    });

    this.setState({
      test: dataTable,
    });
  }

  render() {
    return (
      <MainLayout
        title={"Thống kê chi tiết dự án quy hoạch phân khu 1/5000"}
        {...this.props}
      >
        <div className="page-with-card">
          <Card title="Thống kê chi tiết dự án quy hoạch phân khu 1/5000">
            <div className="thong-ke thong-ke-5000">
              <div style={{ marginLeft: "20px" }}>
                <Row gutter={[20, 0]}>
                  <Col span={6} className="group">
                    <div className="gr-title">
                      <div className="text">Phân khu</div>
                    </div>

                    <div className="gr-body">
                      <Select
                        className="select"
                        showSearch
                        onChange={(e) => {
                          this.setState({ selectedKhu: e });
                        }}
                        value={this.state.selectedKhu}
                        optionFilterProp = "name"
                      >
                        {this.state.listPhanKhu.map((e, i) => (
                          <Select.Option value={e.OBJECTID} key={i} name = {e.TenPhanKhu}>
                            {e.TenPhanKhu}
                          </Select.Option>
                        ))}
                      </Select>
                    </div>
                  </Col>
                </Row>

                <div style={{ display: "flex", margin: "10px 0 15px 0" }}>
                  <Button
                    type="primary"
                    className="button"
                    style={{ width: "117px", fontWeight: 700, height: "40px" }}
                    onClick={this.onResetButton}
                  >
                    Tìm mới
                  </Button>

                  <Button
                    type="primary"
                    className="button"
                    style={{
                      width: "117px",
                      marginLeft: "10px",
                      fontWeight: 700,
                      height: "40px",
                    }}
                    onClick={() => {
                      this.getDataTable();
                    }}
                  >
                    Tìm kiếm
                  </Button>
                </div>
              </div>

              <Spin size="large" spinning={this.state.isLoading}>
                <div style = {{display:  this.state.tableDropdown ? "none" : " "}}>
                  <table id="chart-table" style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <th
                          rowSpan="3"
                          colSpan="2"
                          style={{
                            backgroundImage: `linear-gradient(
                            to top right,
                            #F2F6FB calc(50% - 0.8px),
                            black,
                            #F2F6FB calc(50% + 0.8px)
                          )`,
                            width: "200px",
                            backgroundColor: "#F2F6FB",
                          }}
                        >
                          <div
                            style={{
                              textAlign: "left",
                              marginTop: 60,
                              marginLeft: 20,
                            }}
                          >
                            Phân khu
                          </div>
                        </th>
                        <th rowSpan="3">Tổng đất đô thị</th>
                        <th colSpan="8">Loại đất</th>
                      </tr>

                      <tr>
                        <th colSpan="6">Đất đơn vị ở</th>
                        <th rowSpan="2">Đất đường nội bộ</th>
                        <th rowSpan="2">Đất bãi đỗ xe ĐVO</th>
                      </tr>

                      <tr>
                        <th>Đất công cộng</th>
                        <th>Đất cây xanh, mặt nước</th>
                        <th>Trường tiểu học, THCS</th>
                        <th>Trường mầm non</th>
                        <th>Đất nhóm nhà ở quy hoạch</th>
                        <th>Đất chung cư, nhà ở xã hội</th>
                      </tr>

                      {/* data */}
                      {this.state.dataTable}
                    </tbody>
                  </table>
                </div>

                <div style = {{display:  !this.state.tableDropdown ? "none" : " "}}>
                  <table id="chart-table" style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <th
                          rowSpan="3"
                          colSpan="2"
                          style={{
                            backgroundImage: `linear-gradient(
                            to top right,
                            #F2F6FB calc(50% - 0.8px),
                            black,
                            #F2F6FB calc(50% + 0.8px)
                          )`,
                            width: "200px",
                            backgroundColor: "#F2F6FB",
                          }}
                        >
                          <div
                            style={{
                              textAlign: "left",
                              marginTop: 60,
                              marginLeft: 20,
                            }}
                          >
                            Phân khu
                          </div>
                        </th>
                        <th rowSpan="3">Tổng đất đô thị</th>
                        <th colSpan="8">Loại đất</th>
                      </tr>

                      <tr>
                        <th colSpan="6">Đất đơn vị ở</th>
                        <th rowSpan="2">Đất đường nội bộ</th>
                        <th rowSpan="2">Đất bãi đỗ xe ĐVO</th>
                      </tr>

                      <tr>
                        <th>Đất công cộng</th>
                        <th>Đất cây xanh, mặt nước</th>
                        <th>Trường tiểu học, THCS</th>
                        <th>Trường mầm non</th>
                        <th>Đất nhóm nhà ở quy hoạch</th>
                        <th>Đất chung cư, nhà ở xã hội</th>
                      </tr>
                        
                      {this.state.test}
                    </tbody>
                  </table>
                </div> 

                <div
                  style={{
                    display: "flex",
                    marginTop: "15px",
                    marginBottom: "10px",
                    justifyContent: "center",
                  }}
                >
                  <ReactHtmlTableToExcel
                    id="test-table-xls-button"
                    className="ant-btn ant-btn-primary-cus"
                    table="chart-table"
                    filename={"Thống kê chi tiết dự án quy hoạch chung 1/5000"}
                    sheet="tablexls"
                    buttonText="Tải Excel"
                  />
                  <Button
                    type="primary"
                    className="button"
                    style={{
                      width: "117px",
                      marginLeft: "10px",
                      fontWeight: 700,
                      height: "40px",
                    }}
                    onClick={() =>
                      ChartPrint(
                        "Thống kê chi tiết dự án quy hoạch phân khu 1/5000"
                      )
                    }
                  >
                    In
                  </Button>
                </div>
              </Spin>
            </div>
          </Card>
        </div>
      </MainLayout>
    );
  }
}
